module.exports = __webpack_public_path__ + "img/no_results.84127896.svg";